import { Component, OnInit, Compiler, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { ViewCbsApprovedService } from './view-cbs-approved.service';
import { environment as ENV } from '../../../environments/environment';
import { AuthService } from 'app/laas/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AddCustomerService } from '../add-customer/add-customer.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminAuthService } from '../admin-auth.service';
import * as moment from 'moment';
import { AdminService } from '../admin.service';
import { ApplicantService } from 'app/laas/applicant.service';
import { AdvancedFilterService } from 'app/core/advanced-filter/advanced-filter.service';
// import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
// import { AddCoapplicantComponent} from '../add-coapplicant/add-coapplicant.component'


@Component({
  selector: 'wl-popup',
  providers: [],
  template: `
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<!-- <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" /> -->
<!-- <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"> -->
<!-- <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css"> -->
<style>
   body{
   line-height: 2;
   border: 1px solid grey;
   padding:5px;
   margin: 5px;
   background-color: white;
   }
   .heading{
   color: #0f3f6a;
   }
   .sub-heading{
   color: #0f3f6a;
   font-size: 14px;
   }
   table {
   font-family: arial, sans-serif;
   border-collapse: collapse;
   width: 100%;
   }
   td, th {
   border: 1px solid white;
   text-align: left;
   padding-left: 8px;
   padding-right: 8px;
   }
   tr:nth-child(even) {
   background-color: white;
   }
</style>
</head>
<body id="print" style="margin:20px">

<h4 style="text-align:center">Remarks from Checker</h4>

<wl-label label="Remarks" [value]="detail"></wl-label>


</body>
<div style="display:flex;flex-direction:row;justify-content:center;align-items:center;">
  <wl-button style="flex:1 1 60%;" (click)="closeDialog()" >Close</wl-button>
</div>
<br>
  `,

})

export class PopupComponent {

  roleId: any;
  detail: any;
  data: any;
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private snackbar: MatSnackBar,
    // @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.data = this.modalService.config.initialState;
    console.log("dtaaa ", this.data);
    var rc = this.data;
    this.detail = rc;
  }

  closeDialog() {
    this.bsModalRef.hide();
  }



}

@Component({
  selector: 'wl-view-cbs-approved',
  templateUrl: './view-cbs-approved.component.html',
  styleUrls: ['./view-cbs-approved.component.scss'],
  providers: [ViewCbsApprovedService, AddCustomerService, AdminService],
})
export class ViewCbsApprovedComponent implements OnInit {
  allUsers: Observable<any>;
  loading: boolean;
  search = new UntypedFormControl();
  rocCount: number;
  credCount: number;
  page: number = 1;
  pageId: any = 1;
  totalPage: number = 1;
  totalCount: number;
  noUserFound: string;
  reportLink: string;
  adminId: any;
  custId: any;
  iscredCount: boolean;
  showOrHide: boolean;
  placeHolder: string;
  searchHolder: string;
  roleId: string;
  role: string;
  limit: number = 10;
  offset: number = 0;

  userName: string;
  display: boolean;
  typeText: string;
  adminForm: UntypedFormGroup;
  type: any;
  bsModalRef: BsModalRef;
  isRetail: boolean;
  @ViewChild('date1') firstDate: ElementRef;
  selectedDate: string;
  showSelectedDate: boolean;
  currentDate: any;
  subheading1: string;
  subheading2: string;
  maxDate: string;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  showCbsDataTable: boolean = true;
  filter: string = '';

  constructor(
    private customer: ViewCbsApprovedService,
    private dialog: MatDialog,
    private auth: AuthService,
    private router: Router,
    private jwt: JwtHelperService,
    private snackbar: MatSnackBar,
    private cust: AdminAuthService,
    private fb: UntypedFormBuilder,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    // public modalService: NgbModal
    private modalService: BsModalService,
    private applicant: ApplicantService,
    private advancedFilterService: AdvancedFilterService
  ) {
    this.adminForm = this.fb.group({
      custId: ['', Validators.required],
      name: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]+')])],
      email: [''],
      mobileNo: [''],

      resAdd: [''],
      offAdd: [''],
      resUnitNo: [''],
      offUnitNo: [''],
      employeeName: [''],
      employeeId: [''],
    });

    this.iscredCount = ENV.creditScoreSetting.credCount;
    if (ENV.creditScoreSetting.credMenu == 'shfl') {
      this.showOrHide = false;
    } else {
      this.showOrHide = true;
    }


      this.searchHolder = 'Search Applicant by Name / Customer ID';

      this.display = false;
    
  }

  onSearchClick(event) {
    this.loading = true;
  }

  onSearch(value: string) {
    this.filter = value;
    if (this.isCoLogin()) {
      return this.applyFilter(this.filter, 0, 1, 1);
    }

    this.page = 1;
    this.pageId = 1;
    this.loading = true;
    this.customer.getUsers(value, this.roleId, 0, 10, 'cbs_approved').subscribe({
      next: (res) => {
        this.loading = false;

        if (res && res.success) {
          if (res.result && res.result.resultData && res.result.resultData.length === 0) {
            this.noUserFound = 'Customer data not found';
          } else {
            this.noUserFound = null;
          }
          this.allUsers = res.result.resultData ? res.result.resultData : [];
          this.totalCount = res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        } else {
          this.noUserFound = 'Customer data not found';
          this.allUsers = res.result.resultData ? res.result.resultData : [];
          this.totalCount = 0;
          this.totalPage = 0;
        }
      },
      error: (err) => {
        this.totalCount = 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        this.loading = false;
        throw err;
      },
    });
  }

  ngOnInit() {
    this.roleId = this.customer.getRoleId();
    if (this.isCoLogin()) {
      this.showCbsDataTable = false;
    }

    sessionStorage.removeItem('filterDateViewCustomerReassignedStart');
    sessionStorage.removeItem('filterDateViewCustomerReassignedEnd');
    this.maxDate = this.adminservice.getCurrentMonth();
    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();

    this.currentDate = moment().format('YYYY-MM');
    var encrypted = sessionStorage.getItem('ubknknsviubi--131ss');
    console.log('decrypted ' + JSON.stringify(atob(encrypted)));

    this.role = sessionStorage.getItem('wzbvdsjvbbs');
    console.log('role ' + this.role);

    if (sessionStorage.getItem('filterDateViewCustomerReassigned')) {
      this.currentDate = moment(
        sessionStorage.getItem('filterDateViewCustomerReassigned'),
        'YYYY-MM-DD'
      ).format('YYYY-MM');
      let selected = this.currentDate;
      var months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      var another = months[+selected.split('-')[1] - 1];
      this.selectedDate = another + ', ' + selected.split('-')[0];
      this.showSelectedDate = true;
    }

    this.roleId = sessionStorage.getItem('getroleId');

    console.log('this.roleId ' + this.roleId);
    // getUsers("", roleId,offset/,limit)
    !this.isCoLogin() && this.getAllUsers('', this.roleId, 0, 10);

    this.placeHolder = ENV.placeHolderSetting.placeholder;

    this.adminId = sessionStorage.getItem('wl-admin-id');
  }

  printDes(id) {
    this.applicant.getReportAdmin(id).subscribe((report) => {
      console.log(report);
      // this.reportLink = `${ENV.nodeUrl.slice(0, -2)}${report}`;
      this.reportLink = 'data:application/pdf;base64,' + report;
      const downloadLink = document.createElement('a');
      const fileName = 'Loan-renewal-application.pdf';

      downloadLink.href = this.reportLink;
      downloadLink.download = fileName;

      downloadLink.click();
    });
  }

  printConsent(id) {
    this.applicant.getConsentReportAdmin(id).subscribe((report) => {
      console.log(report);
      // this.reportLink = `${ENV.nodeUrl.slice(0, -2)}${report}`;
      this.reportLink = 'data:application/pdf;base64,' + report;
      const downloadLink = document.createElement('a');
      const fileName = 'Consent-form.pdf';

      downloadLink.href = this.reportLink;
      downloadLink.download = fileName;

      downloadLink.click();
    });
  }

  onDateRangeSelected(dateRange: any) {
    this.pageId = 1;
    this.page = 1;
    this.offset = 0;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let strStart = this.dateInMs.toString();
    sessionStorage.setItem('filterDateViewCustomerReassignedStart', strStart);
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    let strEnd = this.endDateInMs.toString();
    sessionStorage.setItem('filterDateViewCustomerReassignedEnd', strEnd);
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getUsersFilterDate(
          '',
          this.roleId,
          0,
          10,
          this.dateInMs,
          'cbs_approved',
          this.endDateInMs,
          dateType
        )
        .subscribe((res) => {
          console.log(res);
          if (res && res.result && res.result.resultData) {
            this.allUsers = res.result.resultData ? res.result.resultData : '';
            this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
            this.totalPage = Math.ceil(this.totalCount / 10);
          }
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  // submitDates() {
  //   if(this.firstDate.nativeElement.value <= this.maxDate && this.firstDate.nativeElement.value >= '2022-01'  ){
  //   this.showSelectedDate = true;
  //   console.log(this.firstDate.nativeElement.value);
  //   let selected = this.firstDate.nativeElement.value;
  //   var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  //   var another = months[+selected.split('-')[1] - 1];
  //   this.selectedDate = another + ', ' + selected.split('-')[0];
  //   console.log(this.firstDate.nativeElement.value);
  //   let filterDate = this.firstDate.nativeElement.value + '-01';
  //   sessionStorage.setItem('filterDateViewCustomerReassigned',filterDate)
  //   let date = new Date(filterDate);
  //   let dateInMs = date.getTime()
  //   this.customer.getUsersFilterDate("", this.roleId, 0, 10, dateInMs, 'cbs_approved').subscribe(res => {
  //     console.log(res);
  //     if(res && res.result && res.result.resultData){
  //       this.allUsers = res.result.resultData?res.result.resultData:"";
  //       this.totalCount = res && res.result && res.result.count?res.result.count:0;
  //       this.totalPage = Math.ceil(this.totalCount / 10);
  //     }
  //   })
  // }  else{
  //   this.snackbar.open("Please enter the valid date",'OK', {duration:4000})
  // }
  // }

  get_cbs_date(i) {
    if (this.allUsers && this.allUsers[i] && this.allUsers[i]) {
      let sent_to_cbs_date = this.allUsers[i].consent_approval_date
        ? this.allUsers[i].sent_to_cbs_date
        : '';

      if (sent_to_cbs_date) {
        var date = moment(sent_to_cbs_date);
        var dateComponent = date.utc().format('DD-MM-YYYY');
        return dateComponent;
      } else {
        return '';
      }
    }
  }

  get_cbs_approved_date(i) {
    if (this.allUsers && this.allUsers[i] && this.allUsers[i]) {
      let cbs_approved_date = this.allUsers[i].consent_approval_date
        ? this.allUsers[i].cbs_approved_date
        : '';

      if (cbs_approved_date) {
        var date = moment(cbs_approved_date);
        var dateComponent = date.utc().format('DD-MM-YYYY');
        return dateComponent;
      } else {
        return '';
      }
    }
  }

  get_next_renewal_date(i) {
    console.log('clicked', i);
    if (this.allUsers && this.allUsers[i] && this.allUsers[i]) {
      let cbs_approved_date = this.allUsers[i].consent_approval_date
        ? this.allUsers[i].cbs_approved_date
        : '';
      // cbs_approved_date = "2022-05-11T05:15:18.755Z"
      if (cbs_approved_date) {
        let date = moment(cbs_approved_date);
        let dateComponent = date.utc().format('DD-MM-YYYY');
        let yearComponent = date.utc().format('YYYY');
        console.log(date, dateComponent, yearComponent);
        if (this.leapYear(yearComponent)) {
          let newDate = moment(date).add(365, 'days').utc().format('DD-MM-YYYY');
          console.log(newDate);

          return newDate;
        } else if (this.leapYear(yearComponent) == false) {
          let newDate = moment(date).add(364, 'days').utc().format('DD-MM-YYYY');
          console.log(newDate);
          return newDate;
        }
      } else {
        return '';
      }
    }
  }

  test() {
    let cbs_approved_date = '2022-08-01T05:15:18.755Z';
    if (true) {
      let date = moment(cbs_approved_date);
      let dateComponent = date.utc().format('DD-MM-YYYY');
      let yearComponent = date.utc().format('YYYY');
      console.log(dateComponent, yearComponent);

      let new2Date = moment(date).add(365, 'days').utc().format('DD-MM-YYYY');
      console.log(new2Date);
    }
  }

  leapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
  }

  openDialog(text) {
    console.log('user data === > ', text);
    // if (data && data.rcOut.status == 504) {
    //   this.snackbar.open(data.rcOut.error, 'OK', { duration: 2000 });
    // } else if (data && data.rcOut.status == 503) {
    //   this.snackbar.open(data.rcOut.error, 'OK', { duration: 2000 });
    // } else {
    if (text) {
      this.bsModalRef = this.modalService.show(PopupComponent, {
        animated: false,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        initialState: text,
      });
    } else {
      // this.snackbar.open(data.message, 'OK',{duration: 2000});
    }
  }

  getAllUsers(input, roleId, offset, limit) {
    this.loading = true;

    this.customer.getUsers(input, roleId, offset, limit, 'cbs_approved').subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
        }

        // if(res && res.count && res.result.count){
        this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
        this.totalPage = Math.ceil(this.totalCount / 10);
        console.log('this.totalPage ' + this.totalPage);
        // }
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  getAllUsersPage(input, roleId, offset, limit, pageId) {
    if (this.isCoLogin()) {
      return this.applyFilter(input, offset, pageId, pageId);
    }

    this.loading = true;

    console.log('before page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);
    this.page = pageId;
    this.offset = offset;
    this.limit = limit;

    console.log('after page ' + this.page + 'offset ' + this.offset + 'limit ' + this.limit);

    this.customer.getUsers(input, roleId, offset, limit, 'cbs_approved').subscribe(
      (res) => {
        this.loading = false;
        console.log('result ' + JSON.stringify(res));
        if (res && res.result && res.result.resultData) {
          this.allUsers = res.result.resultData ? res.result.resultData : '';
          this.totalCount = res && res.result && res.result.count ? res.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
        }
        console.log('this.totalPage ' + this.totalPage);
      },
      (err) => {
        this.loading = false;
        this.allUsers = Observable[''];
        throw err;
      }
    );
  }

  getRocCount() {
    this.customer.getRocCounts().subscribe((res) => {
      this.rocCount = res;
    });
  }

  retailCheck(isRetail) {
    this.snackbar.open('No Co-Applicant details found', 'OK', { duration: 2000 });
    console.log('retail...1 ', isRetail);
    // this.customer.isRetail = isRetail;
    if (isRetail == true) {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'tDrfsud25362htsjddh');
    } else {
      sessionStorage.setItem('daGeytsjjdbfckwsdld', 'fFywshdssf7d9123dnd');
    }
  }

  getType(app, coapp, guarantor) {
    if (app) {
      return 'Applicant';
    } else if (coapp) {
      return 'Co-Applicant';
    } else {
      return 'Guarantor';
    }
  }


  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    sessionStorage.removeItem('filterDateViewCustomerReassignedStart');
    sessionStorage.removeItem('filterDateViewCustomerReassignedEnd');
    sessionStorage.removeItem('filterDateViewCustomerReassigned');
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }

  isCoLogin() {
    if (this.roleId === '1') {
      return true;
    }
    return false;
  }

  applyFilter(filter: string = '', offset: number = 0, pageId: number = 1, page: number = 1) {
    this.pageId = pageId;
    this.page = page;
    this.offset = offset;
    this.loading = true;
    this.showCbsDataTable = true;
    const formData = this.advancedFilterService.getFilterData();
    formData.filter = filter;
    formData.offset = offset;
    formData.searchFilter = 'cbs_approved';
    try {
      this.customer.getCbsApproved(formData).subscribe(
        (response) => {
          this.noUserFound = '';
          let resultSet =
            response && response.result && response.result.resultData
              ? response.result.resultData
              : [];
          this.allUsers = resultSet;
          if (!resultSet.length) {
            this.noUserFound = 'Customer data not found';
          }
          this.totalCount =
            response && response.result && response.result.count ? response.result.count : 0;
          this.totalPage = Math.ceil(this.totalCount / 10);
          this.loading = false;
        },
        () => {
          this.noUserFound = 'Customer data not found';
          this.loading = false;
          this.totalCount = 0;
          this.totalPage = 0;
        }
      );
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
      this.totalCount = 0;
      this.totalPage = 0;
    }
  }
}
